<script>
  import { animate } from 'animejs'

  import { onMount } from 'svelte'
  import Container from '~/components/ui/container.svelte'

  onMount(() => {
    animate('.headline-animation .el-animated', {
      rotateX: [90, 0],
      duration: 1 * 1000,
    })
  })
</script>

<Container>
  <div class="headline-animation min-h-[30vh] lg:h-auto lg:border-l-2 lg:border-gray-300 lg:px-8">
    <h1 class="el-animated mb-6 text-4xl lg:w-2/3 lg:text-7xl">
      Orçamento com preço fixo e escopo fechado para seu projeto
    </h1>
    <p class="el-animated text-md lg:w-8/12">
      Conte-nos sobre o seu projeto de software, aplicativo, sistema web ou site. Nossa equipe
      analisa e retorna com uma proposta técnica e comercial personalizada, geralmente em até 24
      horas. <span class="sr-only">
        Se preferir, você também pode agendar uma conversa diretamente com um de nossos
        especialistas.
      </span>
    </p>
  </div>

  <hr class="my-[48px]" />
</Container>
